var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-text"},[_c('ion-item',[_c('ion-textarea',{attrs:{"value":_vm.computedValue},on:{"input":_vm.handleInput}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }